import ueditor from './ueditor'
import panel from './panel'
import tabpanel from './tabpanel'
import input from './input/input'
import field from './field'
import block from './block'
import selectTree from './select-tree'
import selectDatadict from './select-datadict'
import scroll from './scroll'
import modal from './modal'
export default { ueditor, panel, input, block, field, tabpanel, selectTree, selectDatadict, scroll, modal}


// WEBPACK FOOTER //
// ./src/components/index.js